import React, { useState, useEffect, useCallback } from 'react'
import { GET_MANY, useClient } from '@peracto/client'
import { StyledSelect } from '@peracto/peracto-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy'

const formatAddress = address => {
    // Because we have many ways of naming addresses
    const formattedAddress = {
        lastName: address?.surname || '',
        firstName: address?.forename || '',
        addressLine1: address?.line1 || '',
        addressLine2: address?.line2 || '',
        addressLine3: address?.line3 || '',
        addressLine4: address?.line4 || '',
        city: address?.city || '',
        county: address?.county || '',
        country: address?.country || '',
        postcode: address?.postalCode || '',
    }

    return formattedAddress
}

const AddressForm = ({ selectedAddress, setSelectedAddress, type, addressData }) => {
    const { client } = useClient()
    const [countries, setCountries] = useState([])

    const fetchCountries = useCallback(async () => {
        try {
            const { data } = await client(GET_MANY, 'countries', {
                id: 'countries',
            })

            const countryOptions = data.map(country => {
                return {
                    label: country.label,
                    value: country.iso3,
                }
            })

            setCountries(countryOptions)
        } catch (e) {
            console.error(e)
        }
    }, [client])

    useEffect(() => {
        if (countries?.length === 0) {
            fetchCountries()
        }
    }, [countries, fetchCountries])

    useEffect(() => {
        if (addressData[type]?.postalCode) {
            const formattedAddress = formatAddress(addressData[type])
            setSelectedAddress(formattedAddress)
        }
    }, [addressData, setSelectedAddress, type])

    return (
        <div>
            <div className="row">
                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="First Name"
                        value={selectedAddress?.firstName}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                firstName: e.target.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="Surname"
                        value={selectedAddress?.lastName}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                lastName: e.target.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="Address Line 1"
                        value={selectedAddress?.addressLine1}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                addressLine1: e.target.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="Address Line 2"
                        value={selectedAddress?.addressLine2}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                addressLine2: e.target.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="Address Line 3"
                        value={selectedAddress?.addressLine3}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                addressLine3: e.target.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="Address Line 4"
                        value={selectedAddress?.addressLine4}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                addressLine4: e.target.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="City"
                        value={selectedAddress?.city}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                city: e.target.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="County"
                        value={selectedAddress?.county}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                county: e.target.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <StyledSelect
                        className="!mb-2 !w-full"
                        placeholder="Country"
                        defaultValue={{ label: 'Country', value: '' }}
                        options={countries}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                country: e.value,
                            })
                        }
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <input
                        className="form-control !mb-2"
                        type="text"
                        placeholder="Postcode"
                        value={selectedAddress?.postcode}
                        onChange={e =>
                            setSelectedAddress({
                                ...selectedAddress,
                                postcode: e.target.value,
                            })
                        }
                    />
                </div>
            </div>

            {type === 'billing' && addressData?.delivery?.postalCode && (
                <div className="row">
                    <div className="col-12">
                        <button
                            className="btn btn-outline-primary"
                            onClick={e => {
                                e.preventDefault()
                                const formattedAddress = formatAddress(addressData.delivery)
                                setSelectedAddress(formattedAddress)
                            }}
                        >
                            <FontAwesomeIcon icon={faCopy} className="!mr-2" />
                            Copy Shipping Address
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AddressForm
